module.exports = __webpack_public_path__ + "img/autospin_btn.4eeffc65.png";